<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import type { PrimitiveProps } from "reka-ui"
import { Primitive } from "reka-ui"
import type { ButtonVariants } from "."
import { cn } from "@/lib/utils"
import { buttonVariants } from "."

// Extends PrimitiveProps for `as` / `asChild`, so a Button can render as a
// NuxtLink, an <a>, or wrap an arbitrary child while keeping the button styling
// — no more hand-rolled `bg-primary …` anchors. Defaults to a real <button>.
interface Props extends PrimitiveProps {
  variant?: ButtonVariants["variant"]
  size?: ButtonVariants["size"]
  class?: HTMLAttributes["class"]
}

const props = withDefaults(defineProps<Props>(), {
  as: "button",
})
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <slot />
  </Primitive>
</template>
